module.exports = __webpack_public_path__ + "img/libyan_labs_logo_white_bg_withtext.1f6f085f.png";